import Vue from "vue";
import {
    Icon
} from "leaflet";
import LeafletMap from './LeafletMap.vue';
import 'leaflet/dist/leaflet.css' //import "leaflet.icon.glyph";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: '/img/marker-icon-2x.png',
  iconUrl: '/img/marker-icon.png',
  shadowUrl: '/img/marker-shadow.png',
});

const appElement = document.querySelector('#map-app');

/* eslint-disable no-new */
new Vue({
    el: '#map-app',
    //    store,
    components: {
        Icon,
        LeafletMap
    },
});
